import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './api';
import {
  RunAutomationPayload,
  GetTaskRunsPayload,
  GetTaskRunsResponse,
  SerchAutomationTicketPayload,
  SearchAutomationTicketResponse,
  GetAutomationFiltersResponse,
  GetAutomationStatisticsPayload,
  GetAutomationStatisticsResponse,
  GetSingleTaskRunResponse,
  AddTasksPayload
} from '../interfaces/automations.interface';

const BASE_URL = `${import.meta.env.VITE_BACKEND_URL}/api/automation`;

export const apiAutomations = createApi({
  reducerPath: 'automation',
  baseQuery: (...args) => baseQueryWithReAuth(...args, { baseUrl: BASE_URL }),
  tagTypes: ['TaskRuns', 'SingleTask', 'Tickets', 'Statistics', 'Filters'],
  endpoints: (build) => ({
    createTaskRun: build.mutation<{ id: string }, RunAutomationPayload>({
      query: (body) => ({
        url: '/create-task-run',
        method: 'POST',
        body
      })
    }),
    addTasks: build.mutation<{ message: string }, AddTasksPayload>({
      query: (body) => ({
        url: '/add-tasks',
        method: 'POST',
        body
      })
      // invalidates tags 'TaskRuns' in Frontend/src/utils/useHandleTaskRun.tsx
    }),
    getTaskRuns: build.query<GetTaskRunsResponse, GetTaskRunsPayload>({
      query: (body) => ({
        url: `/tasks`,
        method: 'POST',
        body
      }),
      providesTags: ['TaskRuns']
    }),
    getSingleTaskRun: build.query<GetSingleTaskRunResponse, string>({
      query: (id) => ({
        url: `/task/${id}`,
        method: 'GET'
      }),
      providesTags: ['SingleTask']
    }),
    searchAutomationTicket: build.query<SearchAutomationTicketResponse, SerchAutomationTicketPayload>({
      query: (body) => ({
        url: '/tasks/search',
        method: 'POST',
        body
      }),
      providesTags: ['Tickets']
    }),
    getAutomationStatistics: build.query<GetAutomationStatisticsResponse, GetAutomationStatisticsPayload>({
      query: (body) => ({
        url: '/tasks/stats',
        method: 'POST',
        body
      }),
      providesTags: ['Statistics']
    }),
    getAutomationFilters: build.query<GetAutomationFiltersResponse, void>({
      query: () => ({
        url: '/tasks/filters',
        method: 'POST'
      }),
      providesTags: ['Filters']
    })
  })
});

export const {
  useGetTaskRunsQuery,
  useGetSingleTaskRunQuery,
  useLazySearchAutomationTicketQuery,
  useGetAutomationFiltersQuery,
  useGetAutomationStatisticsQuery,
  useAddTasksMutation,
  useCreateTaskRunMutation
} = apiAutomations;
